import { createContext, useContext, useEffect, useState } from "react";
import Front from "@frontapp/plugin-sdk";
import { mockData } from "../mock";

/*
 * Context.
 */

export const FrontContext = createContext();

/*
 * Hook.
 */

export function usePluginContext() {
  const context = useContext(FrontContext);

  // if (process.env.REACT_APP_DEBUG_MODE) {
  //   return mockData.context;
  // } else {
    return context;
  // }
}

/*
 * Component.
 */

export const FrontContextProvider = ({ children }) => {
  const [context, setContext] = useState();

  useEffect(() => {
    const subscription = Front.contextUpdates.subscribe((frontContext) => {
      setContext(frontContext);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <FrontContext.Provider value={context}>{children}</FrontContext.Provider>
  );
};
